import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { ImportFileLinkCell } from '../components/ImportFileLinkCell';
import { ImportFileStatusCell } from '../components/ImportFileStatusCell';
import { ImportActionsCell } from '../components/ImportActionsCell';
import { IImportRow } from '../interfaces/IImportRow';

export const initialTableColumns: ITableColumn<IImportRow>[] = [
  {
    id: 'uploadId',
    name: 'Номер загрузки',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'author',
    name: 'Автор',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'ervkProsecutorOrganization',
    name: 'Прокуратура',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knoOrganization',
    name: 'Орган контроля',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'federalLaw',
    name: 'ФЗ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'fileType',
    name: 'Тип загружаемого файла',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'filename',
    name: 'Загруженный файл',
    sort: TableColumnSortEnum.NONE,
    renderCell: ImportFileLinkCell,
  },
  {
    id: 'importedCount',
    name: 'Число обработанных записей',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'uploaded',
    name: 'Дата загрузки файла',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'processed',
    name: 'Дата обработки файла',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'fileStatus',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
    renderCell: ImportFileStatusCell,
  },
  {
    id: 'actions',
    name: 'Действие',
    isDisabledSort: true,
    renderCell: ImportActionsCell,
  },
];
